export const ACCOUNT_PROFILE = 'account.profile';

export const lblProfileSurveyQuestion1 = 'lbl_profile_survey_question1';
export const lblProfileSurveyQuestion1Option1 = 'lbl_profile_survey_question1_option1';
export const lblProfileSurveyQuestion1Option2 = 'lbl_profile_survey_question1_option2';
export const lblProfileSurveyQuestion1Option3 = 'lbl_profile_survey_question1_option3';
export const lblProfileSurveyQuestion1Option4 = 'lbl_profile_survey_question1_option4';
export const lblProfileSurveyQuestion1Option1En = 'lbl_profile_survey_question1_option1_en';
export const lblProfileSurveyQuestion1Option2En = 'lbl_profile_survey_question1_option2_en';
export const lblProfileSurveyQuestion1Option3En = 'lbl_profile_survey_question1_option3_en';
export const lblProfileSurveyQuestion1Option4En = 'lbl_profile_survey_question1_option4_en';
export const lblProfileSurveyQuestion2 = 'lbl_profile_survey_question2';
export const lblProfileSurveyQuestion2Option1 = 'lbl_profile_survey_question2_option1';
export const lblProfileSurveyQuestion2Option2 = 'lbl_profile_survey_question2_option2';
export const lblProfileSurveyQuestion2Option3 = 'lbl_profile_survey_question2_option3';
export const lblProfileSurveyQuestion2Option4 = 'lbl_profile_survey_question2_option4';
export const lblProfileSurveyQuestion2Option5 = 'lbl_profile_survey_question2_option5';
export const lblProfileSurveyQuestion2Option1En = 'lbl_profile_survey_question2_option1_en';
export const lblProfileSurveyQuestion2Option2En = 'lbl_profile_survey_question2_option2_en';
export const lblProfileSurveyQuestion2Option3En = 'lbl_profile_survey_question2_option3_en';
export const lblProfileSurveyQuestion2Option4En = 'lbl_profile_survey_question2_option4_en';
export const lblProfileSurveyQuestion2Option5En = 'lbl_profile_survey_question2_option5_en';

const AboutYouSurveyLabels = {
  account: {
    profile: {
      [lblProfileSurveyQuestion1]: 'How would you best describe yourself?',
      [lblProfileSurveyQuestion1Option1]: 'Parent',
      [lblProfileSurveyQuestion1Option2]: 'Grandparent',
      [lblProfileSurveyQuestion1Option3]: 'Gifting for others',
      [lblProfileSurveyQuestion1Option4]: 'Prefer not to answer',
      [lblProfileSurveyQuestion1Option1En]: 'Parent',
      [lblProfileSurveyQuestion1Option2En]: 'Grandparent',
      [lblProfileSurveyQuestion1Option3En]: 'Gifting for others',
      [lblProfileSurveyQuestion1Option4En]: 'Prefer not to answer',
      [lblProfileSurveyQuestion2]: 'Who are you shopping for?',
      [lblProfileSurveyQuestion2Option1]: 'Girl',
      [lblProfileSurveyQuestion2Option2]: 'Boy',
      [lblProfileSurveyQuestion2Option3]: 'Toddler Girl',
      [lblProfileSurveyQuestion2Option4]: 'Toddler Boy',
      [lblProfileSurveyQuestion2Option5]: 'Baby',
      [lblProfileSurveyQuestion2Option1En]: 'Girl',
      [lblProfileSurveyQuestion2Option2En]: 'Boy',
      [lblProfileSurveyQuestion2Option3En]: 'Toddler Girl',
      [lblProfileSurveyQuestion2Option4En]: 'Toddler Boy',
      [lblProfileSurveyQuestion2Option5En]: 'Baby',
    },
  },
};
export default AboutYouSurveyLabels;
